import React, {Component} from 'react';
import { Link } from "react-router-dom";

import './Modal.css';

export default class Modal extends Component {
    render() {
        return (
            <div className="modal visible" data-content-name="about">
                <div className="content">
                    <h2>About</h2>
                    <Link className="close" to="/">Close popup</Link>
                    <p>In May 2016, I started a project to make one icon everyday. Over one year and 400 icons later, Softies was born.</p>
                    <p>This website was created as an easy way to share the icons for other people to use &amp; get just the icons they need, without having to download a whole set.</p>
                    <p>Just search for an icon, and either download the .svg file or copy the code to directly insert it in your website.</p>
                    <p>These icons are completely free to download and use, but if you have found them helpful, please consider a donation to say thank you!</p>
                </div>
            </div>
        )
    }

}
